"use client";

import { useRef } from "react";

import { PublicNavbar } from "@/app/(public)/_components/public-navbar";
import { PublicPageShell } from "@/app/(public)/_components/public-page-shell";
import { GtmAppMetadata } from "@/app/(public)/waitlist/_components/gtm-app-metadata";
import { HeroVisual } from "@/app/(public)/waitlist/_components/hero-visual";
import { SocialProof } from "@/app/(public)/waitlist/_components/social-proof";
import { WaitlistForm } from "@/app/(public)/waitlist/_components/waitlist-form";

export function WaitlistPage() {
  const formRef = useRef<HTMLElement>(null);

  function scrollToForm() {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  return (
    <PublicPageShell>
      <GtmAppMetadata />
      <PublicNavbar onEarlyAccessClick={scrollToForm} />

      <main className="mx-auto flex w-full max-w-360 flex-1 flex-col px-5 pt-2 pb-6 sm:px-6 sm:pb-8 md:px-10 md:pb-12 lg:grid lg:grid-cols-2 lg:items-center lg:px-14 lg:pt-0">
        <section aria-label="Product preview" className="order-1 w-full shrink-0 lg:order-1">
          <HeroVisual />
        </section>

        <section
          ref={formRef}
          aria-label="Join the waitlist"
          className="order-2 flex w-full flex-col justify-center lg:order-2 lg:pl-2 xl:pl-8">
          <div className="border-border-chip mb-5 inline-flex w-fit items-center gap-2.5 rounded-full border px-3.5 py-2 text-xs sm:mb-6 sm:gap-3 sm:px-4 sm:py-2.5 sm:text-sm">
            <span className="bg-brand-lime size-2 shrink-0 rounded-full" aria-hidden />
            <span className="flex flex-col gap-0.5 leading-tight">
              <span className="text-foreground whitespace-nowrap">
                Ever missed a sport you actually cared about?
              </span>
              <span className="text-[11px] whitespace-nowrap text-[#a3a3a3] sm:text-xs">
                For India&apos;s multi-sport fans. Launching Soon.
              </span>
            </span>
          </div>

          <h1 className="mt-3 text-[1.6rem] leading-[1.08] font-bold tracking-tight min-[400px]:text-[2rem] sm:mt-0 sm:text-4xl lg:text-[2.5rem] xl:text-[3rem]">
            <span className="text-foreground block whitespace-nowrap">Your Sport. Your Time.</span>
            <span className="text-brand-lime block whitespace-nowrap">Nothing Missed.</span>
          </h1>

          <div className="mt-6 sm:mt-8">
            <SocialProof />
          </div>

          <div className="mt-9 w-full sm:mt-8">
            <WaitlistForm />
          </div>
        </section>
      </main>
    </PublicPageShell>
  );
}
